import React from 'react';
import { Progress, Box, Text } from '@chakra-ui/react';

export default function ProgressBar({ value = '0' }) {
    const numericValue = parseFloat(value) || 0;

    let colorScheme = 'green'; // default
    if (numericValue < 30) {
        colorScheme = 'red';
    } else if (numericValue < 70) {
        colorScheme = 'blue';
    }

    return (
        <Box w="200px" display='flex' alignItems='center' >
            <Progress
                value={numericValue}
                colorScheme={colorScheme}
                size="sm"
                borderRadius="md"
                width={85}
            />
            <Text mt={1} fontSize="sm" textAlign="center">
                &nbsp;{numericValue + '%'}
            </Text>
        </Box>
    );
}
